import { RouteRecordRaw } from 'vue-router'
import { metaDataAuthGuard } from '@shared/guards/auth'
import { AuthScope, PermissionLevel } from '@shared/stores/auth'
import type { ExtractRouteNames } from '@shared/types/RouteNames'

// components
const SupportAdmin = () => import(/* webpackChunkName: "SupportAdmin" */ '@support/views/SupportAdmin.vue')
const SupportAdminImpersonation = () => import(/* webpackChunkName: "SupportAdminImpersonation" */ '@support/views/SupportAdminImpersonation.vue')
const SupportAdminDebugging = () => import(/* webpackChunkName: "SupportAdminDebugging" */ '@support/views/SupportAdminDebugging.vue')

// Support admin
export const routes = {
  path: '/support-admin',
  name: 'SupportAdmin',
  component: SupportAdmin,
  beforeEnter: metaDataAuthGuard,
  meta: {
    requiredScopes: [{ level: PermissionLevel.All, scope: AuthScope.Operational }],
  },
  redirect: { name: 'SupportAdminImpersonation' },
  children: [
    // Identity management
    {
      path: 'impersonation',
      name: 'SupportAdminImpersonation',
      beforeEnter: metaDataAuthGuard,
      component: SupportAdminImpersonation,
    },
    {
      path: 'debugging',
      name: 'SupportAdminDebugging',
      beforeEnter: metaDataAuthGuard,
      component: SupportAdminDebugging,
    },
  ] as const satisfies RouteRecordRaw[],
} as const satisfies RouteRecordRaw

export type SupportAdminRouteNames = ExtractRouteNames<typeof routes> | ExtractRouteNames<typeof routes.children[number]>

export default routes
